<template>
    <div class="ai-assistant-dropdown">
        <a-dropdown :trigger="['click']" placement="bottomRight" v-model:visible="visible">
            <!-- 按钮 -->
            <a-button type="default" :disabled="disabled" class="ai-assistant-btn">
                <template #icon>
                    <!-- <RobotOutlined /> -->
                    <img src="@/assets/icons/logo.svg" width="20" alt="" />
                </template>
                AI Assistant
                <DownOutlined v-if="!visible" class="arrow-icon" />
                <UpOutlined v-else class="arrow-icon" />
            </a-button>

            <!-- 下拉菜单 -->
            <template #overlay>
                <div class="bg-white p-2 rounded-[8px]">
                    <div class="px-[8px] rounded-[6px] flex flex-col gap-1 bg-[#eaf0f6] text-[#3F4249]">
                        <div class="py-1 flex justify-between">
                            <div class="flex items-center gap-1">
                                <img src="@/assets/icons/logo.svg" height="16" alt />
                                我的积分
                            </div>
                            <div class="text-[12px] flex items-center text-white bg-[#4998fd] rounded-full p-1">
                                <PlusOutlined />
                                充值
                            </div>
                        </div>
                        <div class="flex justify-between py-1">
                            <span class="text-[#4998fd]">21,035</span>
                            <span>积分</span>
                        </div>
                        <div class="flex justify-between py-1">
                            <span class="text-[#4998fd]">+5,532</span>
                            <span>赠送积分</span>
                        </div>
                    </div>
                    <a-menu @click="handleMenuClick">
                        <a-menu-item v-for="item in menuItems" :key="item.key" :disabled="item.disabled">
                            <component :is="item.icon" class="menu-icon" />
                            <span class="menu-text">{{ item.label }}</span>
                        </a-menu-item>
                    </a-menu>

                </div>
            </template>
        </a-dropdown>
    </div>
</template>

<script setup>
import { ref, computed } from 'vue';
import { useStore } from 'vuex';
import { message } from 'ant-design-vue';
import {
    PlusOutlined,
    DownOutlined,
    UpOutlined,
} from '@ant-design/icons-vue';
import { menuItems } from './menuConfig';
import { doTranslateByUrls } from "@/apis/app.js"

const store = useStore();
const appState = computed(() => store.state.app);
const multiState = computed(() => store.state.multi);

const visible = ref(false);

const disabled = computed(() => {
    return (
        appState.value.editorLoading ||
        !multiState.value.requestId ||
        appState.value.currentMenuAction
    );
});
// 获取当前图片
const getCurrentImage = () => {
    const currentId = multiState.value.requestId;
    if (!currentId || !Array.isArray(multiState.value.imageList)) return null;
    return multiState.value.imageList.find(i => i.requestId === currentId) || null;
};

const doTranslate = async () => {
    const image = getCurrentImage();
    if (!image) {
        message.error('未选择图片或图片信息缺失');
        return;
    }
    const url = image.OriginUrl || image.Url || image.SslUrl
    try {
        await doTranslateByUrls(url);
        // 可选：更新 store 或 local state，通知用户
        message.success('翻译请求已发出');
    } catch (err) {
        message.error('翻译失败');
    }
}

const handleMenuClick = ({ key }) => {
    visible.value = false;



    switch (key) {
        case 'translate':
            // 在那时流程有问题 翻译的流程 包括源语言,目标语言，文件上传
            doTranslate()
            return;
            store.dispatch('app/getTranslateResult', {
                RequestId: multiState.value.requestId
            }).then(() => {
                store.commit('app/SET_EDITOR_LOADING', false);
            });;
            break;
        case 'crop':
            store.commit('app/SET_STATE', {
                currentMenuAction: 'crop'
            });
            break;
        case 'color':
        case 'resize':
        case 'rotate':
            message.info('功能开发中，敬请期待');
            break;
    }
};
</script>

<style lang="less" scoped>
.ai-assistant-dropdown {
    position: absolute;
    top: 16px;
    right: 16px;
    z-index: 10;
}

.ai-assistant-btn {
    background: #ffffff;
    border: 1px solid #e0e0e0;
    border-radius: 10px;
    padding: 8px 16px;
    font-size: 14px;
    font-weight: 500;
    color: #2B8CFF;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    display: flex;
    align-items: center;
    gap: 6px;
    transition: all 0.3s;
    cursor: pointer;
    height: 46px;

    &:hover {
        border-color: #2B8CFF;
        background: #f0f7ff;
        color: #2B8CFF;
    }

    &:focus {
        border-color: #2B8CFF;
        background: #f0f7ff;
    }

    .arrow-icon {
        font-size: 12px;
        margin-left: 4px;
    }
}

:deep(.ant-dropdown-menu) {
    background: #ffffff;
    border: 1px solid #e0e0e0;
    border-radius: 6px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
    min-width: 180px;
    max-height: 400px;
    overflow-y: auto;
    padding: 4px 0;
}

:deep(.ant-dropdown-menu-item) {
    padding: 10px 16px;
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #333333;
    transition: background 0.2s;

    &:hover {
        background: #f5f9ff;
    }

    &.ant-dropdown-menu-item-disabled {
        color: #bbb;
        cursor: not-allowed;

        &:hover {
            background: transparent;
        }
    }

    .menu-icon {
        font-size: 16px;
        margin-right: 8px;
        color: #666;
    }

    .menu-text {
        flex: 1;
    }
}

:deep(.ant-menu-item) {
    padding: 0 8px;
}

:deep(.ant-menu) {
    &.ant-menu-vertical {
        border: none;
    }
}

:deep(.ant-dropdown-menu-item+.ant-dropdown-menu-item) {
    border-top: 1px solid #f0f0f0;
}

@media (max-width: 768px) {
    .ai-assistant-dropdown {
        top: 8px;
        right: 8px;
    }

    .ai-assistant-btn {
        padding: 6px 12px;
        font-size: 13px;

        span:not(.arrow-icon) {
            display: none;
        }
    }
}

@media (min-width: 768px) and (max-width: 1024px) {
    .ai-assistant-dropdown {
        top: 12px;
        right: 12px;
    }
}
</style>
